<template>
  <div class="user-list">

    <user-list-item
        v-for="user in users"
        :key="user.id"
        @openUser="openUser"
        :history="history"
        :user="user"
        :mini="mini"/>
  </div>
</template>

<script>
import UserListItem from "./UserListItem"

export default {
  name: "UserList",
  props: {
    users: {},
    history: {
      type: Boolean
    },
    mini: {
      type: Boolean
    }
  },
  data: () => {
    return {}
  },
  components: {UserListItem},
  computed: {},
  methods: {
    openUser(id) {
      this.$emit('openUser', id)
    }
  }
}
</script>

<style scoped lang="scss">
.user-list {

}
</style>
